import { Container } from 'react-bootstrap'
import UserLayout from '../../layout/Layout';
import AdminLayout from '../../layout/Admin/layout';

function getRole() {
  try {
    const profile = JSON.parse(localStorage.getItem('profileData') || '{}');
    return profile?.roles?.[0] || '';
  } catch {
    return '';
  }
}

function PageNotFound() {
  const isAdmin = getRole() === 'Admin';
  const userData = localStorage.getItem('profileData');
  const content = (
    <div className={!isAdmin && userData ? 'boxes' : ''}>
      <div className={isAdmin ? '' : `charity ${!userData ? 'charity_publicBox' : ''}`}>
        <Container>
          <div className="text-center">
            <div>
              <h1>Oops!</h1>
              <span style={{ fontSize: "100px" }} className="text-warning">404</span>
              <div className="text-danger">
                <b style={{ fontSize: "44px" }}>Page Not Found</b>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );

  if (isAdmin) {
    return <AdminLayout>{content}</AdminLayout>;
  }

  return <UserLayout>{content}</UserLayout>;
}

export default PageNotFound
